import { createFileRoute, notFound, redirect } from '@tanstack/react-router';

import { isPersonExecutive } from 'helpers/person';

export const Route = createFileRoute('/_private/_auth/signup/')({
  beforeLoad: async ({ context }) => {
    if (isPersonExecutive(context.user)) {
      const userId = context.user.id ?? context.user.uuid;
      if (!userId) {
        throw notFound({ throw: true });
      }
      throw redirect({
        params: { userId },
        replace: true,
        to: '/users/$userId/people',
      });
    }

    // @ts-ignore
    const metadata = window.Clerk?.user?.publicMetadata || {};

    if (
      'onboarding_complete' in metadata &&
      metadata.onboarding_complete === true
    ) {
      throw redirect({ to: '/' });
    }
  },
});
